export enum RedirectionsContexts {
  policyDetailsMotorSantander = 'policyDetailsMotorSantander',
}

export interface GeneralAPI {
  getAttributes: (attributes: string[]) => Promise<Record<string, string>>;
}

export interface ShellApi {
  genericApi: GeneralAPI;
}

export type GenericRedirection = {
  [RedirectionsContext in RedirectionsContexts]: (
    queryMap: Record<string, string | number>,
    navigateImmediately?: boolean
  ) => string | void;
};

export interface ShellObject extends GenericRedirection {
  api: ShellApi;
}

declare global {
  interface Window {
    shell: ShellObject;
  }
}
